<template>
  <div>
    <v-data-iterator
        v-if="items.length"
        :search="search"
        :items="items"
        :items-per-page="pageSize"
        disable-pagination
        :hide-default-footer="items.length < pageSize"
        style="overflow-y: auto"
        no-data-text="Δεν βρέθηκαν αποτελέσματα"
        no-results-text="Δεν βρέθηκαν αποτελέσματα"
    >
      <template v-slot:header v-if="items.length > 15">
        <v-text-field
            class="ml-4 mr-4"
            v-model="search"
            label="Αναζήτηση"
            single-line
            append-icon="mdi-magnify"
            hide-details
            clearable
        ></v-text-field>
      </template>
      <template v-slot:default="props">
        <v-list :max-height="maxHeight">
          <v-list-item v-for="item in props.items" :dense="isMobile" :to="'/lift/' + item.Project_ID">
            <v-list-item-action>
              <v-btn small fab color="faded">
                <wnl-unit-icon></wnl-unit-icon>
              </v-btn>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.BranchAddress }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ item.ProjectName }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

      </template>
    </v-data-iterator>
    <v-card-text v-if="!items.length">
      Δεν υπάρχουν βλάβες ή συντηρήσεις
    </v-card-text>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import WnlUnitIcon from "@/wl-unit-text/WnlUnitIcon";

export default {
  name: "ProjectList",
  components: {WnlUnitIcon},
  data: () => ({
    search: '',
  }),
  props: {
    pageSize: {type: Number, default: 15, required: false},
    maxHeight: {type: String, default: '50vh', required: false},
    projectItems: {type: Array, default: null, required: false}
  },
  computed: {
    items() {
      return (this.projectItems ? this.projectItems : this.projects).map(pr => {
        return {
          ...pr,
          BranchAddress: this.branch(pr.Branch_ID).BranchAddress
        }
      })
    },
    ...mapGetters([
      'projects',
      'branch',
      'isMobile'
    ])
  }
}
</script>

<style scoped>

</style>
